import DisciplineDetail from "@/pages/DisciplineDetail";

export default function Grappling() {
  return <DisciplineDetail slug="grappling" orariId="bjj-grappling" />;
}
